const FIELD_NAME_MAP = {
  soDienThoai: "Số điện thoại",
  so_dien_thoai: "Số điện thoại",
  sdt: "Số điện thoại",
  phone: "Số điện thoại",
  phoneNumber: "Số điện thoại",
  hoVaTen: "Họ và tên",
  ho_va_ten: "Họ và tên",
  hoTen: "Họ và tên",
  ho_ten: "Họ và tên",
  fullName: "Họ và tên",
  ten: "Tên",
  name: "Tên",
  tenDangNhap: "Tên đăng nhập",
  ten_dang_nhap: "Tên đăng nhập",
  username: "Tên đăng nhập",
  email: "Email",
  matKhau: "Mật khẩu",
  mat_khau: "Mật khẩu",
  password: "Mật khẩu",
  matKhauCu: "Mật khẩu cũ",
  mat_khau_cu: "Mật khẩu cũ",
  oldPassword: "Mật khẩu cũ",
  matKhauMoi: "Mật khẩu mới",
  mat_khau_moi: "Mật khẩu mới",
  newPassword: "Mật khẩu mới",
  confirmPassword: "Xác nhận mật khẩu",
  tmpPassword: "Mật khẩu tạm thời",
  diaDiem: "Địa điểm",
  dia_diem: "Địa điểm",
  ngayTiepDan: "Ngày tiếp dân",
  ngay_tiep_dan: "Ngày tiếp dân",
  tenCanBo: "Tên cán bộ",
  ten_can_bo: "Tên cán bộ",
  caTiepDan: "Ca tiếp dân",
  ca_tiep_dan: "Ca tiếp dân",
  batDau: "Thời gian bắt đầu",
  bat_dau: "Thời gian bắt đầu",
  ketThuc: "Thời gian kết thúc",
  ket_thuc: "Thời gian kết thúc",
  ghiChu: "Ghi chú",
  ghi_chu: "Ghi chú",
  moTa: "Mô tả",
  mo_ta: "Mô tả",
  description: "Mô tả",
  tenLinhVuc: "Tên lĩnh vực",
  ten_linh_vuc: "Tên lĩnh vực",
  nguoiQuanLyIds: "Người quản lý",
  nguoi_quan_ly: "Người quản lý",
  permissionCodes: "Danh sách quyền",
  permission_codes: "Danh sách quyền",
  permissions: "Quyền hạn",
  vaiTro: "Vai trò",
  vai_tro: "Vai trò",
  role: "Vai trò",
  roleId: "Vai trò",
  role_id: "Vai trò",
  maPhanAnh: "Mã phản ánh",
  ma_phan_anh: "Mã phản ánh",
  tieuDe: "Tiêu đề",
  tieu_de: "Tiêu đề",
  title: "Tiêu đề",
  noiDung: "Nội dung",
  noi_dung: "Nội dung",
  content: "Nội dung",
  diaChi: "Địa chỉ",
  dia_chi: "Địa chỉ",
  address: "Địa chỉ",
  trangThai: "Trạng thái",
  trang_thai: "Trạng thái",
  status: "Trạng thái",
  isActive: "Trạng thái hoạt động",
  is_active: "Trạng thái hoạt động",
  file: "Tệp tin",
  files: "Danh sách tệp tin",
  danhMuc: "Danh mục",
  danh_muc: "Danh mục",
  danhMucId: "Danh mục",
  linhVuc: "Lĩnh vực",
  linh_vuc: "Lĩnh vực",
  linhVucId: "Lĩnh vực",
  coSoDichVuCongId: "Cơ sở dịch vụ công",
  uyBanId: "Ủy ban",
  maOtp: "Mã OTP",
  ma_otp: "Mã OTP",
  otp: "Mã OTP",
  recaptchaToken: "Mã xác thực reCAPTCHA",
  lyDo: "Lý do",
  ly_do: "Lý do",
  reason: "Lý do",
};

export const getFieldLabel = (fieldName) => {
  if (!fieldName) return "";
  const cleanField = String(fieldName).replace(/^"|"$/g, "").trim();
  return FIELD_NAME_MAP[cleanField] || cleanField;
};

export const translateValidationMessage = (rawMessage, fieldName = "") => {
  if (!rawMessage || typeof rawMessage !== "string") return "";

  let msg = rawMessage.trim();

  // Nếu câu thông báo đã chứa tiếng Việt thì giữ nguyên
  if (/[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđĐ]/.test(msg)) {
    return msg;
  }

  // Tách tên field nếu thông báo có dạng "soDienThoai" is not allowed...
  const quotedMatch = msg.match(/^"([^"]+)"\s*(.*)$/);
  let field = fieldName;
  let rest = msg;

  if (quotedMatch) {
    if (!field) field = quotedMatch[1];
    rest = quotedMatch[2].trim();
  }

  const label = getFieldLabel(field) || field || "Trường này";

  // Các mẫu lỗi tiếng Anh phổ biến từ Joi / validation
  if (/is not allowed to be empty/i.test(rest) || /cannot be empty/i.test(rest)) {
    return `${label} không được để trống`;
  }
  if (/is required/i.test(rest)) {
    return `${label} là trường bắt buộc`;
  }
  if (/must be a valid email/i.test(rest) || /must be an email/i.test(rest)) {
    return `${label} không đúng định dạng email`;
  }
  if (/length must be at least (\d+) characters/i.test(rest)) {
    const len = rest.match(/length must be at least (\d+) characters/i)[1];
    return `${label} phải có ít nhất ${len} ký tự`;
  }
  if (/length must be less than or equal to (\d+) characters/i.test(rest)) {
    const len = rest.match(/length must be less than or equal to (\d+) characters/i)[1];
    return `${label} không được vượt quá ${len} ký tự`;
  }
  if (/must contain at least (\d+) items/i.test(rest) || /must have at least (\d+) items/i.test(rest)) {
    const len = rest.match(/must (?:contain|have) at least (\d+) items/i)[1];
    return `${label} phải có ít nhất ${len} lựa chọn`;
  }
  if (/must be a number/i.test(rest)) {
    return `${label} phải là số`;
  }
  if (/must be a string/i.test(rest)) {
    return `${label} phải là chuỗi ký tự`;
  }
  if (/must be a boolean/i.test(rest)) {
    return `${label} phải là giá trị đúng/sai (boolean)`;
  }
  if (/must be an array/i.test(rest)) {
    return `${label} phải là một danh sách`;
  }
  if (/must be a valid GUID/i.test(rest) || /must be a valid UUID/i.test(rest)) {
    return `${label} không hợp lệ (UUID không đúng)`;
  }
  if (/fails to match the required pattern/i.test(rest)) {
    return `${label} không đúng định dạng yêu cầu`;
  }
  if (/is not allowed/i.test(rest)) {
    return `${label} không được phép`;
  }
  if (/must be one of/i.test(rest)) {
    return `${label} không nằm trong danh sách cho phép`;
  }
  if (/must be greater than/i.test(rest)) {
    return `${label} giá trị không hợp lệ`;
  }
  if (/must be less than/i.test(rest)) {
    return `${label} giá trị không hợp lệ`;
  }

  return `${label}: ${rest}`;
};

export const parseApiErrorMessage = (error, defaultMsg = "Đã xảy ra lỗi!") => {
  if (!error) return defaultMsg;
  if (typeof error === "string") return translateValidationMessage(error) || error;

  const responseData = error.response?.data || (error.data ? error.data : null);

  if (responseData) {
    // 1. Nếu có mảng errors chi tiết trả về từ API
    if (Array.isArray(responseData.errors) && responseData.errors.length > 0) {
      const translatedErrors = responseData.errors
        .map((errItem) => {
          if (typeof errItem === "string") {
            return translateValidationMessage(errItem);
          }
          if (errItem && typeof errItem === "object") {
            return translateValidationMessage(errItem.message || errItem.msg, errItem.field || errItem.path);
          }
          return null;
        })
        .filter(Boolean);

      if (translatedErrors.length > 0) {
        return translatedErrors.join(". ");
      }
    }

    // 2. Nếu có responseData.message
    if (responseData.message) {
      const msg = responseData.message;
      if (msg === "Dữ liệu không hợp lệ" && responseData.errors) {
        // Bỏ qua generic message
      } else {
        return translateValidationMessage(msg) || msg;
      }
    }

    if (responseData.error && typeof responseData.error === "string") {
      return translateValidationMessage(responseData.error) || responseData.error;
    }
  }

  // Nếu error object có thuộc tính errors
  if (Array.isArray(error.errors) && error.errors.length > 0) {
    const translatedErrors = error.errors
      .map((errItem) => {
        if (typeof errItem === "string") return translateValidationMessage(errItem);
        if (errItem && typeof errItem === "object") {
          return translateValidationMessage(errItem.message || errItem.msg, errItem.field || errItem.path);
        }
        return null;
      })
      .filter(Boolean);
    if (translatedErrors.length > 0) {
      return translatedErrors.join(". ");
    }
  }

  if (error.message) {
    if (error.message === "Dữ liệu không hợp lệ" && error.errors) {
      // ignore generic
    } else {
      return translateValidationMessage(error.message) || error.message;
    }
  }

  return defaultMsg;
};
